import { useCallback, useEffect, useRef, useState } from 'react';
import { lazyLoadHtmlImages } from '../utils/lazyImages';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useAppDispatch } from '../redux/store';
import {
  postLoungeCommentReply,
  fetchStickerLounges,
  addSticker,
  likeCommentReply,
} from '../redux/lounges/slice';
import stickerImage from '../assets/img/stickers.jpg';
import { StickerTabs } from '../components/StickerTabs';
import { selectLounges } from '../redux/lounges/selectors';

import imageicon from '../assets/img/chart-icon1.png';
import emojiicon from '../assets/img/chart-icon2.png';
import { RichTextEditor } from './LazyEditors';
import imageiconh from '../assets/img/chart-icon1h.png';
import emojiiconh from '../assets/img/chart-icon2h.png';
import { EditBox } from '../components/EditBox';
import 'react-quill/dist/quill.snow.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { removeUserLounge } from '../redux/lounges/slice';
import { LikeCommentReply } from '../components/LikeCommentReply';
import { GET_BASE_URL_IMAGE } from '../constants/apiEndpoints';
import { getUserMembershipBadges } from '../utils/userMembershipBadges';
import { getMouseWaitUserAvatarUrl } from '../utils/avatar';
import { insertStickerIntoRichTextEditor } from '../utils/richTextStickerInsert';
import { useResolvedMentionHtml } from '../utils/mentionResolver';
import { formatCommentDate, getReplyPlacementId } from '../utils/commentThread';
import { CommentReportModal } from './CommentReportModal';


type CommentReplyBoxPropsType = {
  replyData: any;
  stickerData: any;
  onReplyToParent?: (
    targetUserName?: string,
    targetReplyId?: any,
    targetReplyText?: string
  ) => void;
  replyComposer?: any;
  depth?: 1 | 2;
  replyingToUserName?: string;
};
type FormData = {
  chat_reply_msg: string;
  chat_id: number;
  chat_reply_id: number;
};

export const CommentReplyBox: React.FC<CommentReplyBoxPropsType> = ({
  replyData,
  stickerData,
  onReplyToParent,
  replyComposer,
  depth = 1,
  replyingToUserName,
}) => {
  const {
    register,
    setValue,
    handleSubmit,
    reset,
    getValues,
    formState: { errors },
  } = useForm<FormData>();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { stickerPickItems, items } = useSelector(selectLounges);

  const [commentData, SetCommentData] = useState<any | []>(replyData);
  const [showSticker, SetShowSticker] = useState<any | string>(false);
  const [stickerSelection, SetStickerSelection] = useState<any | string>(null);
  const loginuserid = localStorage.getItem('user_id');
  const replyUser = replyData.replyuser ?? replyData.user ?? {};
  const membershipBadges = getUserMembershipBadges(replyUser, items);
  useEffect(() => {
    SetStickerSelection(stickerPickItems.toString());
  }, [stickerPickItems]);

  const textRef = useRef(null);

  function converTime(datevalue: any) {
    const date = new Date(datevalue);
    const formattedDate = date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
    });
    return formattedDate;
  }

  const modules = {
    toolbar: false,
  };

  const [text, setText] = useState('');
  useEffect(() => {
    setValue('chat_reply_msg', text);
  }, [setValue, text]);

  const openSticker = () => {
    SetShowSticker(!showSticker);
  };

  const syncTextToForm = (nextText: string) => {
    setText(nextText);
    setValue('chat_reply_msg', nextText, { shouldDirty: true });
  };

  const onClickSticker = (data: any) => {
    insertStickerIntoRichTextEditor(textRef, data, text, syncTextToForm);
  }

  const [Notify, setIsNotify] = useState<any | string>();
  const [RemoveType, setRemoveType] = useState<any | string>('R');
  const onRemove = (ban_chat_id: any) => {
    dispatch<any>(removeUserLounge({ ban_chat_id, RemoveType })).then(
      (res: any) => {
        window.location.reload();
        // Notify(toast('Comment Removed'));
      }
    );
  };

  const [editbox, SetEditBox] = useState<any | string>(false);
  const [reportOpen, setReportOpen] = useState(false);
  const openReport = () => {
    if (localStorage.getItem('token') == null) {
      navigate('/disneyland/login');
    } else {
      setReportOpen(true);
    }
  };
  const showEditBox = () => {
    SetEditBox(!editbox);
  };

  // const formattedMessage = (message: string) => {
  //   var domParser = new DOMParser();
  //   var doc = domParser.parseFromString(message, 'text/html');
  //   var links = doc.querySelectorAll('.mention');
  //   links.forEach(function (linkTag: any) {
  //     var aTag = document.createElement('a');
  //     // aTag.href = `https://mousewait.xyz/mousewaitnew/disneyland/user/${linkTag.dataset.id}/mypost`;
  //     aTag.href = `../../user/${linkTag.dataset.id}/mypost`;

  //     aTag.style.color = '#0000EE';
  //     aTag.style.marginRight = '3px';
  //     aTag.innerHTML = linkTag.innerHTML;
  //     linkTag.parentNode.replaceChild(aTag, linkTag);
  //   });
  //   return doc.body.innerHTML;
  // };

  const formatedMsg = useResolvedMentionHtml(replyData.chat_reply_msg);

  useEffect(() => {
    if (process.env.NODE_ENV === 'development' && process.env.DEBUG_COMMENTS) {
      console.log('[CommentReplyBox] Formatted message:', formatedMsg);
    }
  }, [formatedMsg]);

  return (
    <>      
      <div
        className={`mid-comm-s mid-comm-s2 mw-comment-reply-wrap mw-comment-reply-wrap--depth-${depth}`}
      >
        <div className='comm-bo mw-comment-card mw-comment-reply-card d-flex'>
          <div className='small-c mw-comment-avatar'>
            <Link to={`/disneyland/user/${replyUser?.user_id}/mypost`}>
              <img
                src={getMouseWaitUserAvatarUrl(
                  replyUser,
                  GET_BASE_URL_IMAGE +
                    '/disneyland/images/thumbs/' +
                    replyUser?.image
                )}
                className='com-imggg'
                alt={`${replyUser?.user_name || 'MouseWaiter'} avatar`}
              />
            </Link>
          </div>
          <div className='comm-c mw-comment-main d-flex'>
            <div className='mw-comment-header'>
              <div className='mw-comment-author-row'>
                <Link
                  className='mw-comment-author-name'
                  to={`/disneyland/user/${replyUser?.user_id}/mypost`}
                >
                  {replyUser?.user_name}
                </Link>
                {membershipBadges.map((badge) => (
                  <span
                    key={badge.key}
                    className={`mw-comment-badge ${badge.className}`}
                    title={badge.title}
                  >
                    {badge.label}
                  </span>
                ))}
              </div>
              <div className='com-tt mw-comment-stats mw-comment-reply-stats'>
                <span className='mw-comment-date'>
                  {formatCommentDate(replyData?.chat_reply_date)}
                </span>
                <span>{replyUser?.rank}</span>
                <span>#{replyUser?.position}</span>
              </div>
            </div>

            {replyingToUserName && (
              <div className='mw-comment-replying-to'>
                Replying to <strong>@{replyingToUserName}</strong>
              </div>
            )}

            <div className='commentlist mw-comment-message'>
              <div
                dangerouslySetInnerHTML={{
                  __html: lazyLoadHtmlImages(formatedMsg)
                    .replace('<p>', '<span>')
                    .replace('</p>', '</span>')
                    .replace('<br>', ''),
                }}
              />
            </div>

            <div className='co-l mw-comment-actions mw-comment-reply-actions'>
              <LikeCommentReply
                likecount={replyData.no_of_likes}
                chat_id={replyData.chat_id}
                comment_id={replyData.chat_reply_id}
                reply_id={replyData.id}
                commnet_userid={replyUser.user_id}
                type={'R'}
                page={'DL'}
              />
              {onReplyToParent && (
                <button
                  type='button'
                  onClick={() =>
                    onReplyToParent(
                      replyUser?.user_name,
                      replyData.id ?? replyData.reply_id ?? replyData.chat_reply_reply_id,
                      replyData.chat_reply_msg
                    )
                  }
                >
                  Reply
                </button>
              )}
              {replyUser.user_id == loginuserid && (
                <>
                  <button type='button' onClick={showEditBox}>Edit</button>
                  <button
                    type='button'
                    onClick={() => {
                      if (window.confirm('Delete this reply?')) onRemove(replyData.id);
                    }}
                  >
                    Delete
                  </button>
                </>
              )}
              <button
                type='button'
                className='mw-comment-action--quiet'
                onClick={openReport}
              >
                Flag
              </button>
            </div>
          </div>
        </div>
        <CommentReportModal
          isOpen={reportOpen}
          onClose={() => setReportOpen(false)}
          itemId={getReplyPlacementId(replyData)}
          type='CR'
          park='DL'
        />
        <EditBox
          replyData={''}
          id={replyData.id}
          chatId={replyData.chat_id}
          chat_reply_id={replyData.chat_reply_id}
          chat_reply_msg={replyData.chat_reply_msg}
          stickerData={stickerData}
          editbox={editbox}
          type={'R'}
        />
        {replyComposer}
      </div>
    </>
  );
};
